import { handleActions } from 'redux-actions';
import { RoomsValue, RoomsFilterCount } from 'ha/types/SearchFilters';

import { Actions } from '../constants';
import { RoomsFilterState } from './Types';

export const initialState = {
  bedroomCount: [],
  listingCount: {},
};

interface Payload {
  filtersCount: {
    rooms: RoomsFilterCount;
  };
  bedroomCount: RoomsValue;
}

export default handleActions<RoomsFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.rooms,
    }),

    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { bedroomCount = [] } },
    ) => ({
      ...state,
      bedroomCount: Array.isArray(bedroomCount) ? bedroomCount : [bedroomCount],
    }),
  },
  initialState,
);
